const user = {
  state: {
    inited: false,
    user: {},
    company: {},
    permissions: []
  },
  mutations: {
    SET_USER: (state, user) => {
      state.user = user
      state.inited = true
    },
    SET_COMPANY: (state, company) => {
      state.company = company
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },
    SET_USERNAME: (state, name) => {
      state.user.username = name
    },
    REMOVE_USER: (state, name) => {
      state.inited = false
    }
  },
  actions: {
    SetUser ({ commit }, res) {
      return new Promise(resolve => {
        commit('SET_USER', res.user)
        commit('SET_COMPANY', res.user.company)
        commit('SET_PERMISSIONS', res.user.permissions)
        resolve(res.user.permissions)
      })
    },
    RemoveUser ({ commit }) {
      commit('REMOVE_USER')
    },
    SetUserName ({ commit }, name) {
      commit('SET_USERNAME', name)
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js